<template>
  <svg
    :style="spinnerStyle"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_25932_121472)">
      <path
        d="M9.99992 4.26852C9.60895 4.26852 9.29199 3.9516 9.29199 3.56059V0.70793C9.29199 0.316914 9.60895 0 9.99992 0C10.3909 0 10.7079 0.316914 10.7079 0.70793V3.56063C10.7079 3.9516 10.3909 4.26852 9.99992 4.26852Z"
        :fill="color"
      />
      <path
        opacity="0.52"
        d="M9.99992 19.999C9.60895 19.999 9.29199 19.6821 9.29199 19.2911V16.4384C9.29199 16.0474 9.60895 15.7305 9.99992 15.7305C10.3909 15.7305 10.7079 16.0474 10.7079 16.4384V19.2911C10.7079 19.6821 10.3909 19.999 9.99992 19.999Z"
        :fill="color"
      />
      <path
        opacity="0.58"
        d="M13.5119 19.3112C13.2328 19.3112 12.9683 19.145 12.8563 18.8707L11.7783 16.2296C11.6305 15.8676 11.8042 15.4544 12.1662 15.3067C12.5279 15.1587 12.9413 15.3325 13.0891 15.6945L14.1671 18.3356C14.3149 18.6976 14.1412 19.1109 13.7792 19.2585C13.6916 19.2944 13.601 19.3112 13.5119 19.3112Z"
        :fill="color"
      />
      <path
        opacity="0.94"
        d="M12.4334 4.74601C12.3443 4.74601 12.2537 4.72914 12.1662 4.69332C11.8042 4.54566 11.6305 4.13238 11.7783 3.77039L12.8563 1.12926C13.004 0.767265 13.4172 0.593085 13.7792 0.741405C14.1412 0.889062 14.3149 1.30234 14.1671 1.66434L13.0891 4.30547C12.9771 4.57984 12.7126 4.74601 12.4334 4.74601Z"
        :fill="color"
      />
      <path
        opacity="0.46"
        d="M6.48812 19.3113C6.39902 19.3113 6.30844 19.2944 6.22086 19.2586C5.85887 19.1109 5.68519 18.6976 5.83297 18.3356L6.91098 15.6945C7.05875 15.3325 7.47191 15.1587 7.83391 15.3067C8.1959 15.4544 8.36957 15.8676 8.2218 16.2296L7.14379 18.8708C7.0318 19.1451 6.76727 19.3113 6.48812 19.3113Z"
        :fill="color"
      />
      <path
        opacity="0.36"
        d="M1.39684 14.2209C1.1177 14.2209 0.853164 14.0549 0.741172 13.7804C0.593399 13.4184 0.76707 13.0052 1.12902 12.8575L3.77012 11.7795C4.13207 11.6313 4.54531 11.8052 4.69309 12.1673C4.84086 12.5293 4.66719 12.9425 4.30523 13.0902L1.66414 14.1683C1.57656 14.2041 1.48594 14.2209 1.39684 14.2209Z"
        :fill="color"
      />
      <path
        opacity="0.82"
        d="M15.9623 8.27266C15.6831 8.27266 15.4186 8.1066 15.3066 7.83215C15.1588 7.47016 15.3325 7.05691 15.6945 6.90922L18.3355 5.83117C18.6974 5.68309 19.1108 5.85688 19.2585 6.21902C19.4063 6.58102 19.2326 6.99426 18.8707 7.14195L16.2296 8.22C16.142 8.25578 16.0514 8.27266 15.9623 8.27266Z"
        :fill="color"
      />
      <path
        opacity="0.24"
        d="M4.03743 8.27254C3.94833 8.27254 3.85774 8.25567 3.77012 8.21985L1.12903 7.1418C0.767037 6.99415 0.593404 6.58086 0.741177 6.21887C0.888912 5.85688 1.30204 5.68325 1.66415 5.83102L4.30524 6.90907C4.66723 7.05672 4.84086 7.47001 4.69309 7.832C4.5811 8.10633 4.31653 8.27254 4.03743 8.27254Z"
        :fill="color"
      />
      <path
        opacity="0.7"
        d="M18.6029 14.2207C18.5138 14.2207 18.4232 14.2038 18.3356 14.168L15.6945 13.0899C15.3325 12.9423 15.1588 12.529 15.3066 12.167C15.4544 11.8053 15.8675 11.6315 16.2296 11.7792L18.8707 12.8572C19.2327 13.0049 19.4063 13.4182 19.2585 13.7802C19.1465 14.0545 18.882 14.2207 18.6029 14.2207Z"
        :fill="color"
      />
      <path
        opacity="0.88"
        d="M14.5526 6.15563C14.3715 6.15563 14.1903 6.08649 14.0521 5.94825C13.7756 5.67185 13.7756 5.2236 14.052 4.9472L16.0691 2.93005C16.3456 2.65353 16.7938 2.65353 17.0703 2.93005C17.3467 3.20646 17.3468 3.6547 17.0703 3.9311L15.0532 5.94825C14.915 6.08649 14.7338 6.15563 14.5526 6.15563Z"
        :fill="color"
      />
      <path
        opacity="0.4"
        d="M3.42958 17.2777C3.24841 17.2777 3.06728 17.2086 2.92903 17.0703C2.65259 16.7939 2.65255 16.3457 2.92899 16.0693L4.9461 14.0521C5.22255 13.7756 5.67079 13.7756 5.94724 14.0521C6.22368 14.3285 6.22372 14.7768 5.94727 15.0532L3.93017 17.0703C3.79192 17.2086 3.61071 17.2777 3.42958 17.2777Z"
        :fill="color"
      />
      <path
        opacity="0.18"
        d="M5.4467 6.15555C5.26549 6.15555 5.0844 6.08641 4.94612 5.94816L2.92901 3.93102C2.65256 3.65461 2.65256 3.20637 2.92905 2.92996C3.20545 2.65355 3.6537 2.65355 3.93018 2.92996L5.94729 4.94711C6.22374 5.22352 6.22374 5.67176 5.94725 5.94816C5.80905 6.08641 5.62784 6.15555 5.4467 6.15555Z"
        :fill="color"
      />
      <path
        opacity="0.64"
        d="M16.5697 17.2776C16.3885 17.2776 16.2074 17.2085 16.0692 17.0702L14.052 15.0531C13.7756 14.7767 13.7756 14.3284 14.0521 14.052C14.3285 13.7756 14.7768 13.7756 15.0532 14.052L17.0703 16.0692C17.3468 16.3456 17.3468 16.7938 17.0703 17.0702C16.9321 17.2085 16.7509 17.2776 16.5697 17.2776Z"
        :fill="color"
      />
      <path
        opacity="0.3"
        d="M3.56051 10.7079H0.70793C0.316953 10.7079 0 10.3909 0 9.99992C0 9.60891 0.316953 9.29199 0.70793 9.29199H3.56051C3.95148 9.29199 4.26844 9.60891 4.26844 9.99992C4.26844 10.3909 3.95148 10.7079 3.56051 10.7079Z"
        :fill="color"
      />
      <path
        opacity="0.76"
        d="M19.292 10.7079H16.4394C16.0484 10.7079 15.7314 10.3909 15.7314 9.99992C15.7314 9.60891 16.0484 9.29199 16.4394 9.29199H19.292C19.683 9.29199 20 9.60891 20 9.99992C20 10.3909 19.683 10.7079 19.292 10.7079Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_25932_121472">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  size: {
    type: Number,
    default: 20
  },
  color: {
    type: String,
    default: '#005E54'
  },
  duration: {
    type: Number,
    default: 1
  }
});

const spinnerStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  animation: `spin ${props.duration}s linear infinite`
}));
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>